import utagLinkGeneric from './utagLinkGeneric';

function trackWishlist ({
	eventAction, eventCategory = 'Wish List', eventLabel = '', nonInteraction = 0
}) {

	utagLinkGeneric({
		eventCategory,
		eventAction,
		eventLabel,
		nonInteraction
	});

}

export default trackWishlist;
